export default function WhatWontWorkSection() {
  const mistakes = [
    {
      title: "Walking into a passport agency without an appointment",
      description: "Regional passport agencies are appointment-only. There is no walk-in service. Appointments in 2026 book 2–4 weeks in advance.",
    },
    {
      title: "Calling the National Passport Information Center",
      description: "They can give you information but cannot expedite your application or get you an appointment faster.",
    },
    {
      title: "Going to the post office for emergency service",
      description: "Post offices process standard applications. They cannot provide emergency service or speed up processing.",
    },
    {
      title: "Using an online passport renewal service",
      description: "Online renewal through the State Dept. is for routine service only. It cannot be expedited for emergency situations.",
    },
    {
      title: "Waiting to see if your current application speeds up",
      description: "If you already have an application in process and it's not moving fast enough, call us. We may be able to help escalate through our agency contacts.",
    },
  ];

  return (
    <section className="bg-amber-50 py-20 md:py-28">
      <div className="max-w-4xl mx-auto px-4 md:px-8">
        <div className="text-center mb-10">
          <p className="text-amber-700 text-xs font-bold uppercase tracking-[0.2em] mb-3">Important Warning</p>
          <h2 className="font-serif text-3xl md:text-4xl font-bold text-[#1A365D] mb-4">
            What <span className="text-red-600">Won't Work</span> in a Passport Emergency
          </h2>
          <p className="text-gray-600 text-base max-w-2xl mx-auto">
            These are the most common mistakes people make in a passport emergency. Don't waste precious time on any of these.
          </p>
        </div>

        <div className="space-y-3">
          {mistakes.map((item, i) => (
            <div key={i} className="bg-white rounded-lg border border-amber-200 p-5 flex items-start gap-4">
              <div className="w-8 h-8 rounded-full bg-red-100 flex items-center justify-center flex-shrink-0 mt-0.5">
                <span className="text-red-600 font-bold text-sm">✗</span>
              </div>
              <div>
                <h4 className="font-bold text-[#1A365D] text-sm mb-1">{item.title}</h4>
                <p className="text-gray-500 text-sm leading-relaxed">{item.description}</p>
              </div>
            </div>
          ))}
        </div>

        <div className="mt-10 text-center bg-white rounded-lg border border-amber-200 p-6">
          <p className="text-[#1A365D] font-semibold mb-3">
            Instead, call a registered courier with direct agency access: Fast Passport Center at 877-253-0084.
          </p>
          <a
            href="tel:8772530084"
            className="inline-flex items-center gap-2 bg-red-600 hover:bg-red-700 text-white font-bold text-sm px-7 py-3.5 rounded-md transition-all hover:scale-105 whitespace-nowrap"
          >
            <i className="ri-phone-line"></i> Call 877-253-0084
          </a>
        </div>
      </div>
    </section>
  );
}